
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as entity from '../entity'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {BlockedIP} from '../entity/BlockedIP';
import {FieldModelBlockedIP} from '../entity/BlockedIP';

/**
 * BlockedIPEventLogGetResult struct
 */
class BlockedIPEventLogGetResult {
  /**
   * Initialize struct
   * @param {!Array=} blockedIPLog
   * @constructor
   */
  constructor (blockedIPLog = []) {
    this.BlockedIPLog = blockedIPLog
  }

  /**
   * Copy struct (shallow copy)
   * @this {!BlockedIPEventLogGetResult}
   * @param {!BlockedIPEventLogGetResult} other Other struct
   * @returns {!BlockedIPEventLogGetResult} This struct
   */
  copy (other) {
    if (other.BlockedIPLog != null) {
      this.BlockedIPLog = []
      for (let item of other.BlockedIPLog) {
        if (item != null) {
          let tempItem
          tempItem = BlockedIP.fromObject(item)
          this.BlockedIPLog.push(tempItem)
        } else {
          this.BlockedIPLog.push(null)
        }
      }
    } else {
      this.BlockedIPLog = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!BlockedIPEventLogGetResult}
   * @returns {!BlockedIPEventLogGetResult} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new BlockedIPEventLogGetResultModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new BlockedIPEventLogGetResultModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!BlockedIPEventLogGetResult}
   * @param {!BlockedIPEventLogGetResult} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof BlockedIPEventLogGetResult)) {
      throw new TypeError('Instance of BlockedIPEventLogGetResult is required!')
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!BlockedIPEventLogGetResult}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    return {
      BlockedIPLog: ((this.BlockedIPLog != null) ? Array.from(this.BlockedIPLog, item => ((item != null) ? item : null)) : null)
    }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return BlockedIPEventLogGetResult.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!BlockedIPEventLogGetResult} other Object value
   * @returns {!BlockedIPEventLogGetResult} Created struct
   */
  static fromObject (other) {
    return new BlockedIPEventLogGetResult().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!BlockedIPEventLogGetResult}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return BlockedIPEventLogGetResult.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!BlockedIPEventLogGetResult}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 3043
  }
}

export { BlockedIPEventLogGetResult };

/**
 * Fast Binary Encoding BlockedIPEventLogGetResult field model
 */
class FieldModelBlockedIPEventLogGetResult extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this.BlockedIPLog = new fbe.FieldModelVector(new FieldModelBlockedIP(buffer, 4 + 4), buffer, 4 + 4)
  }

  /**
   * Get the field size
   * @this {!FieldModelBlockedIPEventLogGetResult}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelBlockedIPEventLogGetResult}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.BlockedIPLog.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelBlockedIPEventLogGetResult}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.BlockedIPLog.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelBlockedIPEventLogGetResult}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelBlockedIPEventLogGetResult.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelBlockedIPEventLogGetResult}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 3043
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelBlockedIPEventLogGetResult}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelBlockedIPEventLogGetResult}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.BlockedIPLog.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.BlockedIPLog.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.BlockedIPLog.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelBlockedIPEventLogGetResult}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelBlockedIPEventLogGetResult}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelBlockedIPEventLogGetResult}
   * @param {!BlockedIPEventLogGetResult} fbeValue Default value, defaults is new BlockedIPEventLogGetResult()
   * @returns {!BlockedIPEventLogGetResult} BlockedIPEventLogGetResult value
   */
  get (fbeValue = new BlockedIPEventLogGetResult()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelBlockedIPEventLogGetResult}
   * @param {!BlockedIPEventLogGetResult} fbeValue BlockedIPEventLogGetResult value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.BlockedIPLog.fbeSize) <= fbeStructSize) {
      this.BlockedIPLog.get(fbeValue.BlockedIPLog)
    } else {
      fbeValue.BlockedIPLog.length = 0
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.BlockedIPLog.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelBlockedIPEventLogGetResult}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelBlockedIPEventLogGetResult}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelBlockedIPEventLogGetResult}
   * @param {!BlockedIPEventLogGetResult} fbeValue BlockedIPEventLogGetResult value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelBlockedIPEventLogGetResult}
   * @param {BlockedIPEventLogGetResult} fbeValue BlockedIPEventLogGetResult value
   */
  setFields (fbeValue) {
    this.BlockedIPLog.set(fbeValue.BlockedIPLog)
  }
}

export { FieldModelBlockedIPEventLogGetResult };

/**
 * Fast Binary Encoding BlockedIPEventLogGetResult model
 */
class BlockedIPEventLogGetResultModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelBlockedIPEventLogGetResult(this.buffer, 4)
  }

  /**
   * Get the BlockedIPEventLogGetResult model
   * @this {!BlockedIPEventLogGetResultModel}
   * @returns {!FieldModelBlockedIPEventLogGetResult} model BlockedIPEventLogGetResult model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!BlockedIPEventLogGetResultModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!BlockedIPEventLogGetResultModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return BlockedIPEventLogGetResultModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!BlockedIPEventLogGetResultModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelBlockedIPEventLogGetResult.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!BlockedIPEventLogGetResultModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!BlockedIPEventLogGetResultModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!BlockedIPEventLogGetResultModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!BlockedIPEventLogGetResultModel}
   * @param {!BlockedIPEventLogGetResult} value BlockedIPEventLogGetResult value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!BlockedIPEventLogGetResultModel}
   * @param {!BlockedIPEventLogGetResult} value BlockedIPEventLogGetResult value, defaults is new BlockedIPEventLogGetResult()
   * @return {!object} Deserialized BlockedIPEventLogGetResult value and its size
   */
  deserialize (value = new BlockedIPEventLogGetResult()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new BlockedIPEventLogGetResult(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new BlockedIPEventLogGetResult(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!BlockedIPEventLogGetResultModel}
   * @param {!number} prev Previous BlockedIPEventLogGetResult model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { BlockedIPEventLogGetResultModel };
